/* =========================================================================
   Alama Studio · Form delle landing v2 e v3 (sections/alama-v2-form.liquid)
   L'invio del form #v2-lead-form: validazione, prefisso del telefono, invio al
   ponte CRM, redirect alla pagina di ringraziamento. E' la logica del form di
   alama-trade-v3.js (live, invariato), con le modifiche decise da Matteo il
   2026-10-05: telefono e «Tell us about the project» obbligatori, prefisso
   internazionale. Stesso payload, stesso ponte, stesso redirect (il Lead di
   Meta scatta sulla pagina di ringraziamento), stesso evento info_form_submit.
   alama-trade-v3.js non aggancia questo form: cerca #lead-form.
   Caricato con defer dopo alama-trade-v3.js e prima di alama-landing-v2.js,
   la cui rete sull'invio resta: se qui qualcosa si rompe prima di
   preventDefault, il lead non parte in GET e il visitatore vede l'errore.
   ========================================================================= */
(function () {
  'use strict';

  var BRIDGE_URL = 'https://alama-crm-bridge.weareuncommon.workers.dev';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FIELDS = 'input[required], select[required], textarea[required]';

  // Come track() di alama-trade-v3.js: dataLayer e gtag se presenti, mai un errore in pagina.
  function track(eventName, params) {
    params = params || {};
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    } catch (e) { /* il tracciamento non rompe mai la pagina */ }
  }

  // Prefissi condivisi da piu' paesi: chi scrive +1 o +44 vede Stati Uniti o Regno Unito.
  // Il numero inviato non cambia: cambia solo il nome sotto il selettore.
  var MAIN = { '1': 'US', '7': 'RU', '39': 'IT', '44': 'GB', '47': 'NO', '61': 'AU', '212': 'MA',
    '262': 'RE', '290': 'SH', '358': 'FI', '500': 'FK', '590': 'GP', '599': 'CW' };
  // Lingua del browser senza paese («de», non «de-DE»): il paese piu' probabile. «en» non decide.
  var LANG = { it: 'IT', fr: 'FR', de: 'DE', es: 'ES', pt: 'PT', nl: 'NL', el: 'GR', ru: 'RU',
    ja: 'JP', zh: 'CN', ko: 'KR', tr: 'TR', pl: 'PL', sv: 'SE', da: 'DK', nb: 'NO', nn: 'NO',
    no: 'NO', fi: 'FI', cs: 'CZ', hu: 'HU', ro: 'RO', he: 'IL', uk: 'UA' };

  function digits(v) { return String(v || '').replace(/\D/g, ''); }

  // Il telefono come lo si scrive o lo si incolla: via i segni invisibili di direzione (iOS, WhatsApp e
  // Contatti li aggiungono copiando un numero), «＋» a larghezza piena come «+», cifre arabe, persiane
  // e a larghezza piena come 0-9 (tastiere del Golfo e giapponesi). Senza, il prefisso scritto non si
  // riconosce e finirebbe due volte nel numero, e le cifre non latine sparirebbero.
  function normPhone(v) {
    return String(v || '')
      .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g, '')
      .replace(/\uFF0B/g, '+')
      .replace(/[\u0660-\u0669\u06F0-\u06F9\uFF10-\uFF19]/g, function (c) {
        var n = c.charCodeAt(0);
        return String(n - (n >= 0xFF10 ? 0xFF10 : n >= 0x06F0 ? 0x06F0 : 0x0660));
      });
  }
  var INTL = /^[\s(]*(\+|00)/;   // numero scritto col prefisso: +39…, 0039…, (+39)…

  // Nomi del campo Country che non sono quelli dell'elenco dei prefissi
  var ALIAS = { uae: 'AE', emirates: 'AE', dubai: 'AE', 'abu dhabi': 'AE', sharjah: 'AE',
    ksa: 'SA', saudi: 'SA', riyadh: 'SA', jeddah: 'SA', doha: 'QA', muscat: 'OM', manama: 'BH',
    uk: 'GB', england: 'GB', scotland: 'GB', wales: 'GB', 'northern ireland': 'GB', 'great britain': 'GB',
    britain: 'GB', london: 'GB', usa: 'US', us: 'US', america: 'US', 'united states of america': 'US',
    italia: 'IT', deutschland: 'DE', schweiz: 'CH', suisse: 'CH', svizzera: 'CH', espana: 'ES',
    holland: 'NL', nederland: 'NL', 'the netherlands': 'NL', 'monte carlo': 'MC', turkey: 'TR',
    'czech republic': 'CZ', 'hong kong': 'HK', 'south korea': 'KR', korea: 'KR', russia: 'RU' };
  // minuscole, senza accenti, punti, apostrofi e spazi doppi: «U.A.E.» = «uae», «Côte d’Ivoire» = «cote divoire»
  function fold(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[.'\u2019]/g, '').replace(/\s+/g, ' ').trim();
  }

  function init(form) {
    if (!form || form.getAttribute('data-v2-form') === 'on') return;
    form.setAttribute('data-v2-form', 'on');

    var submitBtn = form.querySelector('#submit-btn');
    var btnLabel = submitBtn ? submitBtn.querySelector('.btn-label') : null;
    var SUBMIT_LABEL = btnLabel ? btnLabel.textContent : '';
    var errorMsg = form.querySelector('#form-error');
    var code = form.querySelector('#f-phone-code');
    var phone = form.querySelector('#f-phone');
    var dialOut = form.querySelector('.phone-field__dial');
    var country = form.querySelector('#f-country');
    var sending = false;
    var picked = false;   // il prefisso l'ha scelto chi compila: dal selettore, o scrivendo il numero col +

    /* --- Prefisso -------------------------------------------------------- */
    function current() { return code && code.selectedIndex > -1 ? code.options[code.selectedIndex] : null; }
    function dialOf(opt) { return opt ? (opt.getAttribute('data-dial') || '') : ''; }
    function hasIso(iso) { return !!(code && iso && code.querySelector('option[value="' + iso + '"]')); }
    function syncDial() { if (dialOut) dialOut.textContent = dialOf(current()); }
    function selectIso(iso) {
      if (!hasIso(iso)) return false;
      code.value = iso;
      syncDial();
      return true;
    }
    function isoForDial(cc) {
      if (digits(dialOf(current())) === cc) return code.value;   // il paese scelto ha gia' quel prefisso
      if (MAIN[cc] && hasIso(MAIN[cc])) return MAIN[cc];
      for (var i = 0; i < code.options.length; i++) {
        if (digits(dialOf(code.options[i])) === cc) return code.options[i].value;
      }
      return '';
    }

    // Paese della lingua del browser (navigator.languages): il primo con un paese nell'elenco.
    function browserCountry() {
      var langs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < langs.length; i++) {
        var m = /^([a-z]{2,3})(?:-[a-z]{4})?(?:-([a-z]{2}))?(?:-|$)/i.exec(langs[i] || '');
        if (!m) continue;
        if (m[2] && hasIso(m[2].toUpperCase())) return m[2].toUpperCase();
        if (!m[2] && LANG[m[1].toLowerCase()]) return LANG[m[1].toLowerCase()];
      }
      return '';
    }

    // Numero scritto col prefisso (+44 7700…, 0044 7700…): il selettore passa a quel paese e nel
    // campo resta il numero. I prefissi E.164 non sono mai l'inizio di un altro, quindi la prima
    // corrispondenza (3, 2, poi 1 cifra) e' l'unica. Un prefisso che non c'e' nell'elenco (reti
    // satellitari) resta scritto com'e' e parte com'e'.
    function absorbInternational() {
      if (!code || !phone) return;
      var v = normPhone(phone.value);
      if (v !== phone.value) phone.value = v;   // il campo mostra le cifre che partiranno
      var m = INTL.exec(v);
      if (!m) return;
      var rest = v.slice(m[0].length);
      var d = digits(rest);
      for (var len = 3; len >= 1; len--) {
        if (d.length <= len) continue;
        var iso = isoForDial(d.slice(0, len));
        if (!iso) continue;
        var seen = 0, k = 0;
        while (k < rest.length && seen < len) { if (/\d/.test(rest.charAt(k))) seen++; k++; }
        selectIso(iso);
        picked = true;
        // via la parentesi chiusa di «(+39) 333…»; quelle del numero restano: «(212) 555-0123»
        phone.value = rest.slice(k).replace(/^[\s\-.\/)]+/, '');
        return;
      }
    }

    // Paese scritto in Country -> codice: alias, poi i nomi dell'elenco
    function countryIso(text) {
      var t = fold(text);
      if (!t || !code) return '';
      if (ALIAS[t] && hasIso(ALIAS[t])) return ALIAS[t];
      for (var i = 0; i < code.options.length; i++) {
        if (fold(code.options[i].textContent.replace(/\s*\(\+\d+\)\s*$/, '')) === t) return code.options[i].value;
      }
      return '';
    }

    // Se il prefisso non l'ha scelto chi compila (era quello della lingua del browser, o l'Italia),
    // segue il paese scritto in Country: il paese di lavoro dice del telefono piu' della lingua del
    // browser, che per molti (Golfo compreso) e' l'inglese americano.
    function followCountry() {
      if (picked || !code || !country) return;
      var iso = countryIso(country.value);
      if (iso && iso !== code.value) selectIso(iso);
    }

    function isInternational(v) { return INTL.test(v || ''); }

    // Il numero senza prefisso; nel piano nordamericano senza l'1 iniziale che alcuni scrivono
    function nationalDigits() {
      var d = digits(normPhone(phone ? phone.value : ''));
      if (digits(dialOf(current())) === '1' && d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      return d;
    }

    // Prefisso, uno spazio, le sole cifre: «+39 3331234567». Al massimo 18 caratteri.
    function composedPhone() {
      var raw = normPhone(phone ? phone.value : '');
      if (isInternational(raw)) return '+' + digits(raw.replace(/^[\s(]*00/, ''));
      if (!code) return raw.trim();   // senza selettore (markup cambiato): il numero com'e', come nel live
      return dialOf(current()) + ' ' + nationalDigits();
    }

    // Obbligatorio. Niente lettere; 4 cifre almeno nel numero, da 7 a 16 col prefisso (E.164 ne
    // ammette 15, piu' lo zero iniziale che in molti paesi si scrive): al massimo 18 caratteri. Il CRM
    // rifiuta l'intero lead per un telefono che non gli sembra valido; se e' Frappe, come fanno pensare
    // endpoint e messaggio d'errore, il limite e' 20.
    function phoneValid() {
      var raw = normPhone(phone ? phone.value : '').trim();
      if (raw === '' || /[a-z]/i.test(raw)) return false;
      if (isInternational(raw)) {
        var all = digits(raw.replace(/^[\s(]*00/, ''));
        return all.length >= 7 && all.length <= 15;
      }
      var national = nationalDigits();
      if (!code) return national.length >= 6;   // senza selettore: la regola del live (6 cifre almeno)
      var dial = digits(dialOf(current()));
      // +1: 10 cifre, la prima da 2 a 9, come ogni numero nordamericano. Un numero di un altro paese
      // rimasto col +1 della lingua del browser (050 123 4567) non passa, e il messaggio chiede di
      // controllare il prefisso
      if (dial === '1') return /^[2-9]\d{9}$/.test(national);
      var total = dial.length + national.length;
      return dial.length > 0 && national.length >= 4 && total >= 7 && total <= 16;
    }

    /* --- Validazione ----------------------------------------------------- */
    function wrapOf(field) { return field.closest('.form-row--split > div') || field.closest('.form-row'); }

    function validateField(field) {
      var ok;
      if (field === phone) ok = phoneValid();
      else if (field.type === 'email') ok = EMAIL_RE.test(field.value.trim());
      else ok = field.value.trim() !== '';
      var wrap = wrapOf(field);
      if (wrap) wrap.classList.toggle('invalid', !ok);
      field.setAttribute('aria-invalid', String(!ok));
      return ok;
    }

    function validateForm() {
      absorbInternational();
      followCountry();
      var ok = true, first = null;
      Array.prototype.forEach.call(form.querySelectorAll(FIELDS), function (f) {
        var v = validateField(f);
        if (!v && !first) first = f;
        ok = ok && v;
      });
      if (first) first.focus();
      return ok;
    }

    // l'errore sparisce mentre si corregge, come nel live
    form.addEventListener('input', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches(FIELDS)) return;
      var wrap = wrapOf(f);
      if (wrap && wrap.classList.contains('invalid')) validateField(f);
    });
    if (code) code.addEventListener('change', function () {   // solo le scelte di chi compila: i cambi da script non lo fanno scattare
      picked = true;
      syncDial();
      var wrap = phone ? wrapOf(phone) : null;
      if (wrap && wrap.classList.contains('invalid')) validateField(phone);
    });
    if (country) country.addEventListener('change', function () {
      followCountry();
      var wrap = phone ? wrapOf(phone) : null;
      if (wrap && wrap.classList.contains('invalid')) validateField(phone);
    });
    if (phone) phone.addEventListener('change', function () {
      absorbInternational();
      var wrap = wrapOf(phone);
      if (wrap && wrap.classList.contains('invalid')) validateField(phone);
    });

    /* --- Invio: come alama-trade-v3.js --------------------------------- */
    function submitLead(payload) {
      return fetch(BRIDGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { if (!r.ok) throw new Error('bridge ' + r.status); return r.json(); })
        .then(function (d) { if (!d || !d.ok) throw new Error('crm'); return d; });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      if (errorMsg) errorMsg.classList.remove('is-visible');
      if (!validateForm()) return;

      var payload = {
        fullName: form.fullName.value.trim(),
        studio: form.studio.value.trim(),
        email: form.email.value.trim(),
        phone: composedPhone(),
        role: form.role.value,
        country: form.country.value.trim(),
        projectType: form.projectType.value || null,
        message: form.message.value.trim(),
        // percorso della pagina («/for-interior-designers-v2»): il ponte lo usa solo per riconoscere la yacht
        page: (location.pathname.match(/\/pages(\/[^\/?#]+)/) || [])[1] || '/for-interior-designers',
        formType: 'info-request',
        submittedAt: new Date().toISOString(),
        _hp: form._hp ? form._hp.value : ''
      };

      sending = true;
      if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.setAttribute('aria-busy', 'true'); }
      if (btnLabel) btnLabel.textContent = 'Sending…';

      submitLead(payload).then(function () {
        track('info_form_submit', { role: payload.role, country: payload.country, projectType: payload.projectType });
        window.location.assign('/pages/thank-you');
      }).catch(function () {
        sending = false;
        if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.removeAttribute('aria-busy'); }
        if (btnLabel) btnLabel.textContent = SUBMIT_LABEL;
        if (errorMsg) errorMsg.classList.add('is-visible');
      });
    });

    // Indietro dalla pagina di ringraziamento: il browser puo' ridare la pagina com'era (bfcache),
    // col bottone su «Sending…». Torna pronto per un altro invio
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      sending = false;
      if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.removeAttribute('aria-busy'); }
      if (btnLabel) btnLabel.textContent = SUBMIT_LABEL;
    });

    /* --- Paese iniziale: per ultimo, il form e' gia' agganciato ---------- */
    try {
      if (code) {
        if (code.value === (code.getAttribute('data-default') || '')) {
          var bc = browserCountry();
          if (bc) selectIso(bc);
        }
        syncDial();
      }
    } catch (e) { /* resta il paese di default */ }
  }

  init(document.getElementById('v2-lead-form'));
  // editor del tema: la sezione rigenerata porta un form nuovo
  document.addEventListener('shopify:section:load', function (e) {
    try { init(e.target && e.target.querySelector ? e.target.querySelector('#v2-lead-form') : null); } catch (err) { /* resta la rete sull'invio */ }
  });
})();
